import React, { useState } from "react";
import { ArrowLeft, Search, X, User, MessageSquare } from "lucide-react";
import { useAppContext } from "../../context/AppContext";

export default function CommunityModal({
  setShowFollowersModal,
  knownUsers,
  allUsers,
  followingList,
  setSelectedChatUser,
  handleStartDM,
  setShowDmInbox,
}: any) {
  const { lang, user } = useAppContext();

  const [userSearch, setUserSearch] = useState("");
  const [userSearchTab, setUserSearchTab] = useState<
    "followers" | "following" | "all"
  >("followers");

  // Фільтрація користувачів (перенесена з Chat.tsx)
  let searchList: any[] = [];
  if (userSearchTab === "followers") {
    const followerIds = allUsers
      .filter((u: any) => u.following?.includes(user?.uid))
      .map((u: any) => u.id);
    searchList = knownUsers.filter((u: any) => followerIds.includes(u.id));
  } else if (userSearchTab === "following") {
    searchList = knownUsers.filter((u: any) => followingList.includes(u.id));
  } else {
    searchList = knownUsers;
  }

  if (userSearch.trim()) {
    searchList = searchList.filter((u: any) =>
      u.name?.toLowerCase().includes(userSearch.toLowerCase())
    );
  }

  return (
    <div className="fixed inset-0 bg-[var(--bg-main)] z-[500] animate-fade-in flex flex-col">
      <div className="bg-[var(--bg-card)] border-b border-[var(--border-color)] px-5 py-4 shrink-0 pt-12 shadow-sm flex items-center gap-3">
        <button
          onClick={() => setShowFollowersModal(false)}
          className="active:scale-95 text-[var(--text-main)]"
        >
          <ArrowLeft size={20} />
        </button>
        <h2 className="font-extrabold text-xl text-[var(--text-main)]">
          {lang === "uk" ? "Спільнота" : "Community"}
        </h2>
      </div>

      <div className="p-4 shrink-0 bg-[var(--bg-card)]">
        <div className="flex items-center gap-2 bg-[var(--bg-soft)] border border-[var(--border-color)] px-3 py-2 rounded-xl">
          <Search size={18} className="text-[var(--text-muted)]" />
          <input
            value={userSearch}
            onChange={(e) => setUserSearch(e.target.value)}
            placeholder={lang === "uk" ? "Пошук..." : "Search..."}
            className="flex-1 bg-transparent outline-none text-sm text-[var(--text-main)]"
          />
          {userSearch && (
            <button onClick={() => setUserSearch("")}>
              <X size={16} className="text-[var(--text-muted)]" />
            </button>
          )}
        </div>
      </div>

      <div className="flex px-4 gap-2 shrink-0 my-3">
        {["followers", "following", "all"].map((tab) => (
          <button
            key={tab}
            onClick={() => setUserSearchTab(tab as any)}
            className={`flex-1 py-2 rounded-xl text-[11px] uppercase font-black border ${
              userSearchTab === tab
                ? "bg-[#a073e7] text-white border-[#a073e7]"
                : "bg-[var(--bg-card)] text-[var(--text-muted)] border-[var(--border-color)]"
            }`}
          >
            {tab === "followers"
              ? lang === "uk"
                ? "Підписники"
                : "Followers"
              : tab === "following"
              ? lang === "uk"
                ? "Підписки"
                : "Following"
              : lang === "uk"
              ? "Всі"
              : "All"}
          </button>
        ))}
      </div>

      <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-3 pb-32">
        {searchList.length === 0 && (
          <div className="text-center py-10 text-[var(--text-muted)] font-bold text-sm">
            Нікого не знайдено
          </div>
        )}
        {searchList.map((u) => (
          <div
            key={u.id}
            className="flex items-center gap-3 bg-[var(--bg-card)] p-3 rounded-2xl border border-[var(--border-color)] shadow-sm animate-slide-up"
          >
            <div
              className="w-12 h-12 rounded-full bg-[var(--accent-soft)] flex items-center justify-center overflow-hidden shrink-0 border border-[var(--border-color)] cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedChatUser({
                  id: u.id,
                  name: u.name,
                  photo: u.photo,
                  breed: u.breed,
                });
              }}
            >
              {u.photo ? (
                <img src={u.photo} className="w-full h-full object-cover" />
              ) : (
                <User size={20} className="text-[#a073e7]" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-bold text-sm text-[var(--text-main)] truncate">
                {u.name || "Без імені"}
              </h4>
              {u.breed && (
                <p className="text-[10px] text-[var(--text-muted)] font-bold uppercase tracking-wide truncate mt-0.5">
                  {u.breed}
                </p>
              )}
            </div>
            <button
              onClick={() => {
                handleStartDM(u);
                setShowFollowersModal(false);
                setShowDmInbox(true);
              }}
              className="p-2.5 bg-[#a073e7] text-white rounded-xl shadow-md active:scale-95 transition-all"
            >
              <MessageSquare size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
